module.exports = "https://web-assets.ifttt.com/packs/media/plan-badges/pro-fb71a6c9.svg";